export default __webpack_public_path__ + "static/media/Gray.670ab32e.PNG";